import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  Activity, Map, BarChart2, TrendingUp, Calendar,
  Users, Award, MapPin, ArrowUp, ArrowDown, PieChart
} from 'lucide-react';

import OverviewTab from './components/OverviewTab';
import MapView from './components/MapView';
import ComparisonTab from './components/ComparisonTab';
import RankingsTab from './components/RankingsTab';
import PerformanceTab from './components/PerformanceTab';
import AnalyticsTab from './components/AnalyticsTab';

const PulseDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [timeRange, setTimeRange] = useState('7d');
  const navigate = useNavigate();

  const tabs = [
    { id: 'overview', label: 'Overview', icon: Activity },
    { id: 'analytics', label: 'Analytics', icon: PieChart },
    { id: 'map', label: 'Map View', icon: Map },
    { id: 'comparison', label: 'Comparison', icon: BarChart2 },
    { id: 'rankings', label: 'Rankings', icon: Award },
    { id: 'performance', label: 'Performance', icon: TrendingUp }
  ];

  useEffect(() => {
    navigate(`/pulse/${activeTab}`);
  }, [activeTab, navigate]);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-rose-500 to-pink-500 rounded-xl p-6 text-white">
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-2xl font-semibold">Pulse Analytics</h1>
            <p className="text-rose-100 mt-1">
              Comprehensive sales analysis and performance insights
            </p>
          </div>
          
          {/* Time Range Selector */}
          <select
            value={timeRange}
            onChange={(e) => setTimeRange(e.target.value)}
            className="bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-sm font-medium backdrop-blur-sm"
          >
            <option value="24h">Last 24 Hours</option>
            <option value="7d">Last 7 Days</option>
            <option value="30d">Last 30 Days</option>
            <option value="90d">Last Quarter</option>
            <option value="1y">Last Year</option>
            <option value="ytd">Year to Date</option>
          </select>
        </div>

        {/* Centered Tabs */}
        <div className="mt-6 flex justify-center">
          <div className="inline-flex space-x-1 bg-white/10 rounded-lg p-1 backdrop-blur-sm">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    activeTab === tab.id
                      ? 'bg-white text-rose-600'
                      : 'text-white/90 hover:bg-white/10'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {tab.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Routes for Tabs */}
      <Routes>
        <Route path="/" element={<OverviewTab timeRange={timeRange} />} />
        <Route path="/overview" element={<OverviewTab timeRange={timeRange} />} />
        <Route path="/analytics" element={<AnalyticsTab timeRange={timeRange} />} />
        <Route path="/map" element={<MapView timeRange={timeRange} />} />
        <Route path="/comparison" element={<ComparisonTab timeRange={timeRange} />} />
        <Route path="/rankings" element={<RankingsTab timeRange={timeRange} />} />
        <Route path="/performance" element={<PerformanceTab timeRange={timeRange} />} />
      </Routes>
    </div>
  );
};

export default PulseDashboard; 